import { useTranslation } from 'react-i18next';
import { useMemo, useState } from 'react';
import { ParameterDto } from '@src/types/types';
import { Dropdown } from '@components/atoms/Dropdown';
import { ParameterListItems } from '@components/atoms/ParameterListItems';
import { SortOption, sortParameters } from '@utils/parameters';
import { ParameterListHeader } from './ParameterListHeader';

export type ParameterListProps = {
  className?: string;
  parameters?: ParameterDto[];
};

const sortOptions = [
  SortOption.DEVIATION_DESC,
  SortOption.DEVIATION_ASC,
  SortOption.CATEGORY_ASC,
  SortOption.CATEGORY_DESC,
  SortOption.ALPHABET_ASC,
  SortOption.ALPHABET_DESC,
];

export const ParameterList = ({
  className,
  parameters,
}: ParameterListProps) => {
  const { t } = useTranslation('component', { keyPrefix: 'parameterList' });
  const [sortOption, setSortOption] = useState<SortOption>(
    SortOption.DEVIATION_DESC,
  );

  const sortedParameters = useMemo(() => {
    return sortParameters(parameters, sortOption);
  }, [parameters, sortOption]);

  return (
    <div data-testid="parameter-list">
      {sortedParameters.length > 0 && (
        <div className="flex justify-start mb-2 print:hidden">
          <Dropdown
            options={sortOptions}
            value={sortOption}
            displayValue={(option: SortOption): string => {
              return t(`sort.${option}`);
            }}
            handleChange={setSortOption}
            label={t('sort.label')}
            classNameContainer="w-80 w-max-[calc(100%-52px)] mb-6"
            testId="parameter-sort"
          />
        </div>
      )}
      <ParameterListHeader className="mb-4" />
      <ParameterListItems items={sortedParameters} className={className} />
    </div>
  );
};
